export * from './WhatWeTreat';
export * from './content';
export * from './ContentfulWhatWeTreat';
